import * as d3 from 'd3';
import { TDrawModel } from '../../draw.model';

export const DRAW_ELEMENT = {
  addToolTip: (drawModel: TDrawModel, xPosition: number, yPosition: number) => {
    return d3
      .select('body')
      .selectAll('.timeline-tooltip')
      .data([drawModel])
      .join((enter) => {
        const updatedDiv = enter
          .append('div')
          .style('position', 'fixed')
          .style('pointer-events', 'none')
          .style('background-color', '#000')
          .style('color', 'white')
          .style('border', '1px solid #ccc')
          .style('border-radius', '4px')
          .style('padding', '5px')
          .style('font-size', '12px')
          .style('box-shadow', 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px');

        return updatedDiv;
      })
      .attr('class', 'timeline-tooltip fade-in-animation');
  },
  removeToolTip: () => {
    return d3.select('body').selectAll('.timeline-tooltip').remove();
  },
};
